import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { LOGO_WHITE, LOGO_DARK } from "@/lib/brand";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@aiyavi.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin", { replace: true });
  }, [user, navigate]);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin", { replace: true });
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1758304481282-04e7b1ddbeeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxhZXJpYWwlMjB2aWV3JTIwZ3JlZW4lMjBlc3RhdGV8ZW58MHx8fHwxNzc3NTM3ODQ1fDA&ixlib=rb-4.1.0&q=85"
          alt="Aiyavi Retreat"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-earth-900/60 to-earth-900/20" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center">
            <img src={LOGO_WHITE} alt="Aiyavi Retreat" className="h-12 w-auto object-contain" />
          </div>
          <div className="max-w-md">
            <div className="text-xs uppercase tracking-[0.22em] text-sage-200">Admin</div>
            <h1 className="mt-4 font-serif text-5xl font-light leading-tight">
              Curate every detail of the retreat.
            </h1>
            <p className="mt-4 text-white/80 font-light">
              Update hero, gallery, pricing, amenities and replies — all in one place.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-earth-50">
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="w-full max-w-md bg-white rounded-3xl p-10 border border-earth-100 shadow-[0_20px_60px_-20px_rgba(92,64,51,0.2)]"
        >
          <div className="text-xs uppercase tracking-[0.22em] text-sage-600">Sign in</div>
          <h2 className="mt-3 font-serif text-3xl text-earth-900 font-light">Welcome back.</h2>
          <p className="text-sm text-earth-600 mt-2">Use your admin credentials.</p>

          <div className="mt-8 flex flex-col gap-4">
            <div>
              <Label className="text-earth-800">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-earth-800">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="mt-2"
                required
              />
            </div>

            {error && (
              <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="mt-2 w-full bg-earth-900 text-white hover:bg-earth-800 rounded-full py-6"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>

            <a href="/" className="text-xs text-earth-600 hover:text-earth-900 text-center mt-2">
              ← Back to website
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
